module.exports = __webpack_public_path__ + "static/media/windu_round_logo.4d509bd9.svg";